import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124.171 21.34-.029 18.521.003 16",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m19.516 19.888.515.407q-.24.28-.503.54l-1.759-1.262c1.269-1.144 2.062-2.77 2.062-4.575 0-3.236-2.561-5.871-5.831-6.202l.159-1.43a8.3 8.3 0 0 1 1.478.287L15.843 7q.818.24 1.571.627l-.332.597q.697.357 1.305.83l.441-.517q.66.522 1.203 1.158l-.53.419q.501.58.878 1.25l.597-.308q.403.726.65 1.514l-.64.187q.228.713.308 1.482l.664-.063a8 8 0 0 1 0 1.637l-.663-.062a7.4 7.4 0 0 1-.305 1.483l.636.186a8 8 0 0 1-.65 1.513l-.587-.302a7.7 7.7 0 0 1-.873 1.257m-3.458 2.288.184.518q.386-.1.758-.231l-.337-1.117-.803-.407a7.2 7.2 0 0 1-2.026.29A6.8 6.8 0 0 1 9.909 20L9 20.949q.577.407 1.235.714l-.312.499q.722.33 1.503.532l.187-.528q.709.192 1.47.258l-.062.542c.54.045 1.085.045 1.626 0l-.062-.54a9 9 0 0 0 1.473-.25",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m13.667 12.867-1.764 1.227.622-2.056-1.712-1.298 2.148-.044.705-2.03.706 2.03 2.148.044-1.712 1.297.622 2.057zm-.765 5.749c-1.07-.598-2.73-2.1-1.42-4.616.082 1.636 9.992 8.704 10.361 9.039.37.334.652.613.881.993.336.558-.04 1.189-.563.818-.283-.2-.46-.741-.893-1.189-.32-.279-.573-.571-1.38-.712-.038-.007-.05-.09-.019-.127-.075-.043-4.246-2.683-6.967-4.206",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagAgo = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagAgo_default = SvgFlagAgo;

export { FlagAgo_default as default };
